/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Tool annotations providing behavioral hints about the tool
 */
export type ToolAnnotations = {
  /**
   * If true, the tool may perform destructive updates (only meaningful when read_only_hint is false)
   */
  destructiveHint?: boolean | undefined;
  /**
   * If true, repeated calls with same arguments have no additional effect (only meaningful when read_only_hint is false)
   */
  idempotentHint?: boolean | undefined;
  /**
   * If true, the tool interacts with external entities beyond its local environment
   */
  openWorldHint?: boolean | undefined;
  /**
   * If true, the tool does not modify its environment
   */
  readOnlyHint?: boolean | undefined;
  /**
   * Human-readable display name for the tool
   */
  title?: string | undefined;
};

/** @internal */
export const ToolAnnotations$inboundSchema: z.ZodMiniType<
  ToolAnnotations,
  unknown
> = z.pipe(
  z.object({
    destructive_hint: z.optional(z.boolean()),
    idempotent_hint: z.optional(z.boolean()),
    open_world_hint: z.optional(z.boolean()),
    read_only_hint: z.optional(z.boolean()),
    title: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "destructive_hint": "destructiveHint",
      "idempotent_hint": "idempotentHint",
      "open_world_hint": "openWorldHint",
      "read_only_hint": "readOnlyHint",
    });
  }),
);

export function toolAnnotationsFromJSON(
  jsonString: string,
): SafeParseResult<ToolAnnotations, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolAnnotations$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolAnnotations' from JSON`,
  );
}
